import message from "./message.plugin";
import sidebars from "./sidebars.plugin";

export default {
  message,
  sidebars
};
